export const dureeValiditeInformationClient = 3 // Durrée en année

export const dureeMaxConsultationDesFactures = 3 // En année
